import { Button, Modal } from "reactstrap";
import React from "react";

const DeleteModal = ({ open, handleClose, handleDelete, message, title }) => {
  return (
    <>
      <Modal
        fade={false}
        className="modal-dialog-centered"
        isOpen={open}
        toggle={handleClose}
      >
        <div className="modal-header pb-1">
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleClose}
          >
            <span aria-hidden={true}>
              <img src="/close.svg" alt="close" />
            </span>
          </button>
        </div>
        <div className="d-flex justify-content-center">
          <h5 className="modal-title">{title}</h5>
        </div>
        <div className="modal-body d-flex justify-content-center mt-3 py-0">
          {message}
        </div>
        <div className="modal-footer">
          <Button
            className="btn-block modal-primary-btn"
            type="button"
            onClick={handleDelete}
          >
            Delete
          </Button>
          <Button 
          onClick={handleClose} 
          className="btn-block default-secondary-btn bg-transparent" 
          type="button"
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DeleteModal;
